import { render, staticRenderFns } from "./page13.vue?vue&type=template&id=adb2453a&scoped=true&"
import script from "./page13.vue?vue&type=script&lang=js&"
export * from "./page13.vue?vue&type=script&lang=js&"
import style0 from "./page13.vue?vue&type=style&index=0&id=adb2453a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb2453a",
  null
  
)

export default component.exports